module.exports = __webpack_public_path__ + "static/media/5.1a680945.svg";